import { createSlice } from "@reduxjs/toolkit";
import localRepository from "../../localRepository";

const initialState = {
  authState: null,
  isAuthenticated: false,
  isConfirming: false,
  isLoading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authStateSuccess: {
      prepare: (authState) => ({ payload: { authState } }),
      reducer: (state, action) => {
        state.authState = action.payload.authState;
        state.isLoading = false;
        state.isAuthenticated = action.payload.authState ? true : false;
      },
    },
    signInInit: () => initialState,
    signInAction: (state) => {
      state.isLoading = true;
    },
    signInConfirming: (state) => {
      state.isConfirming = true;
      state.isLoading = false;
    },
    signInSuccess: (state) => {
      state.isLoading = false;
      state.isConfirming = true;
    },
    signInFail: (state) => {
      state.isLoading = false;
      state.isConfirming = false;
    },
  },
});

const {
  authStateSuccess,
  signInInit,
  signInAction,
  signInConfirming,
  signInSuccess,
  signInFail,
} = authSlice.actions;

const authStateSync = (authState) => {
  return async (dispatch, getState, services) => {
    try {
      localRepository.accessToken.set(authState.accessToken);

      if (!authState.accessToken) localRepository.clear();

      dispatch(authStateSuccess(authState));
    } catch (error) {
      dispatch(signInFail(error));
      services.sendMessage(
        "No se pudo enviar el mail de confirmación.",
        "error",
      );
    }
  };
};

const signInWithSocial = (callback) => {
  return async (dispatch) => {
    try {
      dispatch(signInAction());
      callback();
    } catch (error) {
      dispatch(signInFail(error));
      console.error(error);
    }
  };
};

const signInWithEmail = (email, loginPasswordlessEmail) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(signInAction());
      await loginPasswordlessEmail(email);

      dispatch(signInConfirming());
    } catch (error) {
      dispatch(signInFail(error));
      services.sendMessage(
        "No se pudo enviar el mail de confirmación.",
        "error",
      );
    }
  };
};

const signInWithEmailConfirmed = (
  { email, emailCode },
  confirmPasswordlessEmail,
) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(signInAction());

      await confirmPasswordlessEmail(email, emailCode);

      dispatch(signInSuccess());
    } catch (error) {
      dispatch(signInFail(error));
      services.sendMessage("Código incorrecto o vencido.", "error");
    }
  };
};

export default authSlice.reducer;
export {
  authStateSync,
  signInWithSocial,
  signInWithEmail,
  signInWithEmailConfirmed,
  signInInit,
  signInAction,
  signInConfirming,
  signInSuccess,
  signInFail,
  authStateSuccess,
};
